import i18n from "@/plugins/i18n";
/** Wire enum name → catalogue i18n key (under contact.detail.relations.create.catalogue). */
const CATEGORY_LABEL_KEYS = {
    Direction: "direction",
    Sales: "commerceSales",
    MarketingCommunication: "marketingCommunication",
    TechnicalIt: "techIT",
    FinanceManagement: "financeManagement",
    HumanResources: "humanResources",
    Support: "supportCustomerService",
    Legal: "legalCompliance",
    Procurement: "purchasesLogistics",
    Other: "other",
    // An unset category reads as "Not specified" (AC) — used as the badge fallback only,
    // never as a subtitle prefix.
    NotSpecified: "notSpecified",
};
/** Wire enum name → catalogue key sent back to the API (matches RelationFunctionCatalogue on BFF). */
const CATEGORY_CATALOGUE_KEYS = {
    Direction: "direction",
    Sales: "commerce_sales",
    MarketingCommunication: "marketing_communication",
    TechnicalIt: "tech_it",
    FinanceManagement: "finance_management",
    HumanResources: "human_resources",
    Support: "support_customer_service",
    Legal: "legal_compliance",
    Procurement: "purchases_logistics",
    Other: "other",
};
const NOT_SPECIFIED = "NotSpecified";
function categoryLabel(functionCategory) {
    const key = CATEGORY_LABEL_KEYS[functionCategory];
    return key ? i18n.global.t(`contact.detail.relations.create.catalogue.${key}`) : null;
}
function toFunction(fn) {
    const label = categoryLabel(fn.functionCategory);
    const title = fn.title?.trim() || null;
    const isSpecified = fn.functionCategory !== NOT_SPECIFIED;
    return {
        id: fn.id,
        // Badge label: the free-text title, falling back to the catalogue label
        // (incl. the "Not specified" label when the category is unset).
        title: title ?? label ?? "",
        // Raw user-entered title — never the catalogue fallback. Pre-fills the edit form.
        editTitle: title ?? "",
        // Subtitle prefix: only a real (specified) category shown alongside a free-text title.
        category: title && isSpecified ? label : null,
        // Catalogue key used when sending PATCH requests back to the API.
        categoryKey: CATEGORY_CATALOGUE_KEYS[fn.functionCategory] ?? null,
        startDate: fn.startDate ?? "",
        endDate: fn.endDate ?? null,
        isCurrent: fn.isCurrent,
    };
}
function toOrganisation(org) {
    return {
        id: org.organisationId,
        name: org.name,
        logoUrl: org.logoUrl ?? null,
        functions: org.functions.map(toFunction),
    };
}
export function mapApiContactRelations(api) {
    return {
        organisations: api.organisations.map(toOrganisation),
        organisationCount: api.organisationCount,
        householdCount: api.householdCount > 0 ? 1 : 0,
    };
}
